import { useOwnerAuth } from "@/components/owner/OwnerAuthProvider";
import { resolveOwnerAuthGate } from "@/lib/onboardingResume";
import { router } from "expo-router";
import { type ReactNode, useEffect } from "react";
import { ActivityIndicator, Text, View } from "react-native";

export default function RequireOwner({ children }: { children: ReactNode }) {
  const { authInitialized, user, ownerReady, ownerError } = useOwnerAuth();
  const state = resolveOwnerAuthGate({
    authInitialized,
    hasUser: !!user,
    ownerReady,
    ownerError,
  });

  useEffect(() => {
    if (state === "signin") {
      router.replace("/(owner)/onboarding/signin");
    }
  }, [state]);

  if (state === "ready") {
    return <>{children}</>;
  }

  if (state === "error") {
    return (
      <View
        style={{
          flex: 1,
          padding: 20,
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "#ffffff",
        }}
      >
        <Text
          style={{
            fontSize: 18,
            fontWeight: "900",
            color: "#111827",
            textAlign: "center",
          }}
        >
          Account setup failed
        </Text>

        <Text
          style={{
            marginTop: 10,
            fontSize: 14,
            color: "#6b7280",
            lineHeight: 20,
            textAlign: "center",
          }}
        >
          You are signed in, but Soko Grid could not prepare your owner account.
          Please confirm Firestore rules were deployed, then restart the app.
        </Text>
      </View>
    );
  }

  return (
    <View
      style={{
        flex: 1,
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#ffffff",
      }}
    >
      <ActivityIndicator />
      <Text style={{ marginTop: 10, fontWeight: "800", color: "#111827" }}>
        Preparing your workspace…
      </Text>
    </View>
  );
}
